import * as yup from "yup";
const phoneRegExp = /^(010|011|012|015)\d{8}$/;
const emailRegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const ArSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "الإسم يجب ألا يقل عن 3 حروف")
    .required("اجباري"),
  email: yup
    .string()
    .matches(emailRegExp, "برجاء ادخال ايميل صحيح")
    .required("اجباري"),
  phoneNumber: yup
    .string()
    .min(11, "يجب أن يكون 11 رقم")
    .max(11, "يجب أن يكون 11 رقم")
    .matches(phoneRegExp, "رقم الهاتف يجب أن يبدأ بـ (010/011/012/015) مباشرة")
    .required("اجباري"),
  subject: yup.string().required("اجباري"),
  message: yup.string().required("اجباري"),
});
